module.exports = {
  siteTitle: 'Yashraj Mishra | Software Engineer',
  siteDescription:
    'Yashraj Mishra is a software engineer based in Jaipur, India who specializes in developing (and occasionally designing) exceptional, high-quality websites and applications.',
  siteKeywords:
    'Yashraj Mishra, software engineer, front-end engineer, web developer, javascript, yashrajmishra, yashraj, mishra',
  siteUrl: 'https://yashraj.amitelectric.in',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-155631039-1',
  googleVerification: 'Y_eSFi8aWEa8xjM8ioA8hk3wc-QcBxZdltdk549ELho',
  name: 'Yashraj Mishra',
  location: 'Jaipur, India',
  email: 'yashraj@amitelectric.in',
  github: 'https://github.com/yashrajmishra',
  twitterHandle: '@MishraYashrajs',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/yashrajmishra',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/yashrajmishra',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/mishra.yashrajs',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/MishraYashrajs',
    },
    {
      name: 'Sourcerer',
      url: 'https://sourcerer.io/yashrajmishra',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
    {
      name: 'Pensieve',
      url: '/pensieve',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#FE8100',
    navy: '#171717',
    darkNavy: '#000000',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
